export const userRights = {
  user: { code: "VCP_USER" },
  dealerAdminUser: { code: "VCP_DEALER_ADMIN" },
  adminUser: { code: "VCP_ADMIN" },
  estimatorOnly: { code: "VCP_ESTIMATOR_ONLY" },
  vendorAdmin: { code: "VCP_VENDOR_ADMIN" },
  all: ["VCP_USER", "VCP_DEALER_ADMIN", "VCP_ADMIN", "VCP_ESTIMATOR_ONLY", "VCP_VENDOR_ADMIN"],
};
